import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const StyledDiv = styled.div`
  height: 100%;
  .wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: hidden;
  }
`

class ContentBody extends Component {
  render = () => {
    let { components, rstyle } = this.props;

    return (
      <StyledDiv style={rstyle}>
        <ReactCSSTransitionGroup
          transitionName="contentSlide"
          transitionAppear={true}
          transitionEnter={true}
          transitionLeave={true}
          transitionAppearTimeout={900}
          transitionLeaveTimeout={900}
          transitionEnterTimeout={900}
          >
          <div className="wrap">
            {components}
          </div>
        </ReactCSSTransitionGroup>

      </StyledDiv>
    )
  }
}

ContentBody.propTypes = {
  components: PropTypes.arrayOf(PropTypes.element),
  rstyle: PropTypes.object
}

export default ContentBody;


// WEBPACK FOOTER //
// ./src/components/instore/ContentBody.js